<div [ngClass]="{'section--first': firstSection && (!leftNavReact || isConsumer) && !visualBackgroundEnabled}" class="mru-component">
    <div *ngIf="initialDocsAvailable || showZeroExperience || hasRecommendedDocs || edgeworthEnabled"
         id="mru-section"
         class="mru-section section--fluent"
         role="region"
         [attr.aria-label]="sectionLandmarkAriaLabel">
        <div [ngClass]="{ 'width-restrictor width-restrictor--responsive': !noGutter, 'width-restrictor--no-gutter': noGutter }" #widthRestrictorElement>
            <ng-container ohpLazyView
                        ngModulePath="create-on-home-wrapper#CreateOnHomeWrapperModule"
                        *ngIf="createOnHomeEnabled">
            </ng-container>
            <ng-container>
                <ohp-recommended *ngIf="!recommendedReact" [fileType]="fileType" [isStartPage]="!!fileType" [isSuggestedActions]="isSuggestedActions"></ohp-recommended>
                <ng-container *ngIf="recommendedReact"
                        ohpLazyView ngModulePath="recommended-react#RecommendedReactModule"
                        [inputs]="{
                            fileType: fileType
                        }">
                </ng-container>
            </ng-container>
            <ng-container ohpLazyView
                        ngModulePath="learning-shelf-react#LearningShelfReactModule"
                        *ngIf="learningShelfEnabled && !homeReorderedEnabled">
            </ng-container>
            <ng-container *ngIf="(initialDocsAvailable || showZeroExperience) && !edgeworthEnabled"
                    ohpLazyView ngModulePath="mru#MruModule"
                    [inputs]="{
                        headless: headless,
                        recentMruStreamData: recentMruStream,
                        fileType: fileType,
                        maxInitialDocs: maxInitialDocs,
                        maxTotalDocs: maxTotalDocs
                    }"
                    [outputs]="mruOutputs">
            </ng-container>
            <ng-container ohpLazyView
                        ngModulePath="edgeworth#EdgeworthModule"
                        *ngIf="edgeworthEnabled && !edgeworthReactEnabled && !quickAccessEnabled"
                        [inputs]="{
                            fileType: fileType
                        }">
            </ng-container>
            <ng-container ohpLazyView
                        ngModulePath="quick-access#QuickAccessReactModule"
                        *ngIf="edgeworthEnabled && quickAccessEnabled">
            </ng-container>
            <ng-container ohpLazyView
                        ngModulePath="learning-shelf-react#LearningShelfReactModule"
                        *ngIf="learningShelfEnabled && homeReorderedEnabled">
           </ng-container>
            <ng-container ohpLazyView
                        ngModulePath="ew-react#EdgeworthReactModule"
                        *ngIf="edgeworthEnabled && edgeworthReactEnabled && !quickAccessEnabled"
                        [inputs]="{
                            fileType: fileType
                        }">
            </ng-container>
        </div>
    </div>
</div>
